import React, {Component} from 'react';
import _ from 'underscore'
import SoldItemPreview from 'components/soldItemPreview';
import {isMobile, dollarsWithoutCents} from 'helpers/ApplicationHelper';
import {chatBotSaveLog} from 'actions/item';


class SimilarItemsCui extends Component {
    constructor(props) {
        super(props);

        this.state = {
            similarItems: _.map(this.props.similarItems, (item)=> {
                if (item.desc.length > 43)
                    item.desc = item.desc.slice(0, 40) + '…';
                return item;
            })
        };
    }

    componentDidMount() {
        //used for cui save log method
        let message = this.props.message;
        message.text = `The following ${this.state.similarItems.length} items were displayed in the popup: ${this.state.similarItems.map((similarItem) => {
            return JSON.stringify({id: similarItem.id, sold_for: dollarsWithoutCents(similarItem.sold_for)})
        })}`
    }


    render(){
        return (
            <div id={this.props.id} className=" ">
                <div className={`similar-items-wrapper${isMobile() ? '-mobile' : '-desktop'}`}>
                    {
                        this.state.similarItems.map(item => {return <SoldItemPreview key={item.id} item={item} page='cui'/>})
                    }
                </div>
            </div>
        );
    }
}

export default SimilarItemsCui;